module.exports = __webpack_public_path__ + "assets/img/beta.291e8627.svg";